module.exports = __webpack_public_path__ + "img/b.1670f529.png";